const initialState: sage.state.IFile = {
    files: {},
    filesStatus: {},
    downloadFileStatus: {},
    fileLookup: {},
    fileLookupStatus: {},
    fileInfoLookup: {},
    fileInfoLookupStatus: {},
};

export default function file(
    state: sage.state.IFile = initialState,
    action: sage.actions.file.ReducerTypes
): sage.state.IFile {
    switch (action.type) {
        case "com.sage.actions.file.ISetFiles":
            return {
                ...state,
                files: {
                    ...state.files,
                    [action.page]: action.files,
                },
            };
        case "com.sage.actions.file.ISetFilesStatus":
            return {
                ...state,
                filesStatus: {
                    ...state.filesStatus,
                    [action.page]: action.status,
                },
            };
        case "com.sage.actions.file.ISetDownloadFileStatus":
            return {
                ...state,
                downloadFileStatus: {
                    ...state.downloadFileStatus,
                    [action.fileId]: action.status,
                },
            };
        case "com.sage.actions.file.ISetFile":
            return {
                ...state,
                fileLookup: {
                    ...state.fileLookup,
                    [action.file.id]: action.file,
                },
            };
        case "com.sage.actions.file.ISetFileStatus":
            return {
                ...state,
                fileLookupStatus: {
                    ...state.fileLookupStatus,
                    [action.fileId]: action.status,
                },
            };
        case "com.sage.actions.file.ISetFileInfoStatus":
            return {
                ...state,
                fileInfoLookupStatus: {
                    ...state.fileInfoLookupStatus,
                    [action.fileId]: action.status,
                },
            };
        case "com.sage.actions.file.ISetFileInfo":
            return {
                ...state,
                fileInfoLookup: {
                    ...state.fileInfoLookup,
                    [action.fileInfo.file_id]: action.fileInfo,
                },
            };
        case "com.sage.actions.file.IClear":
            return initialState;
        default:
            return state;
    }
}
